import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const SubContractorList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { subcontractors, total, page } = data;

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Code</th>
                            <th>Contact Person</th>
                            <th>Contact Number</th>
                            <th>Email</th>
                            <th>Country</th>
                            <th>State</th>
                            <th>City</th>
                            <th>Status</th>
                            <th>Modified By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {subcontractors?.length > 0 ? (
                            subcontractors.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle bg-light text-primary">
                                                {item.SUB_CONTRACTOR_NAME?.charAt(0).toUpperCase()}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{item.SUB_CONTRACTOR_NAME}</td>
                                    <td>{item.SUB_CONTRACTOR_CODE}</td>
                                    <td>{item.CONTACT_PERSON || '-'}</td>
                                    <td>{item.CONTACT_NUMBER || '-'}</td>
                                    <td>{item.EMAIL || '-'}</td>
                                    <td>{item.COUNTRY_NAME || '-'}</td>
                                    <td>{item.STATE_NAME || '-'}</td>
                                    <td>{item.CITY_NAME || '-'}</td>
                                    <td>
                                        <span
                                            className={`badge rounded-pill ${
                                                item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'
                                            }`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editSubContractorMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page: page,
                                                        },
                                                    }}
                                                    title="Edit"
                                                >
                                                    <i className="bx bx-edit text-primary"></i>
                                                </Link>
                                            </li>
                                            <li className="list-inline-item">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => onChangeVisibility(item)}
                                                    title="Change Status"
                                                    className="text-danger"
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="12" className="text-center">
                                    No Subcontractors found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default withRouter(SubContractorList);
